import { render, staticRenderFns } from "./ShippingBill.vue?vue&type=template&id=d89da538&"
import script from "./ShippingBill.vue?vue&type=script&lang=js&"
export * from "./ShippingBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports